export default function ColorsRow(props) {
    const colors = props.rawColors?.split(',')
    if (colors === undefined || colors?.length < 1 || colors[0] == "") return

    return <div id={props.id}
                className={props.elementId < props.currentIndex
                    ? ""
                    : "disabled-options-block"}
    >
        <h3>{props.colorsTitle}</h3>
        <div style={{ display: "flex" }}>
            {colors.map((color, i) => {
                return <div 
                    className="color-option" 
                    key={i}
                    style={{ backgroundColor: color }} 
                    onClick={() => {
                        props.setColor(color)
                        props.setOptionIndex(props.elementId+2)

                        // console.log(color)
                    }}>
                </div>
            })}
        </div>
    </div>
}